const FORM_ENCODED_CONTENT_TYPE = 'application/x-www-form-urlencoded; charset=UTF-8';
const CLIENT_CREDENTIALS = 'mdtcJs:medtronic';




export default {
  customer: [],
  userDomInfo: {
  	theme: 'theme-default'
  },
  AccountDetails : {
		isInit: false,
		user: {
		access: null
		},
		roles: "",
		groups: null,
		pk: null,
		myOrdersPK: null,
		customerDetails: [],
		isCustomerLoaded: false,
		customerDetails:{}
	},
	formConfig: {
		downloadHide: [],
		featureConfiguration: {},
	},
  ajaxCall: {
  	ajaxCallInProgress:false
  },
  meData : {
		openIdConfig: [],
		refreshTokenTimer: null,
		refreshInterval: 50, // in seconds
		decodedClientCredentials: CLIENT_CREDENTIALS,
		clientCredentials: btoa(CLIENT_CREDENTIALS),
		decodedAccessToken: null,
		accessToken: null,
		refreshToken: null,
		userName: null,
		user: null,
		loginError: {},
		isInit: false,
		customerPreferences : null,
		defaultCustomer: null,
		isInternal:false,
		customer: null,
		manageCustomerList: null,
		state: {},
		roles: [],
		distributor: {},
		refreshTokenFlag: false,
		resourceAccess: {},
		hyphenizedCulture: '',
		supportedSuppliers: [],
		meState : {
			AUTHENTICATING: false,
			OPENID_CONFIG: false,
			LOGGED_IN: false,
			USER_DETAILS: false,
			HAS_PERMISSIONS: false,
			HAS_CUSTOMERS : false,
			HAS_RESOURCE_RIGHTS: false,
			FETCHING_PERMISSIONS: false,
			FETCHING_RESOURCE_RIGHTS: false,
			LOGIN_ERROR: false,
			APPLY_ONBOARDING: false
		}
	},

	bootData : {
		riotIsInit: false,
        settings: {},
        translations: {},
        dateConfig: {},
        numberConfig: {},
		screenOverlay: false,
		appConfiguration: {}
	},
	modalPopup :{
		title: "",
        icon: "error",
        contents:[],
        isOpen: false,
        footer: false,
        hasHeader: true
	},
	wishList :{
		wishListId: "",
		wishListName: {},
		entries: [],
		errors: [],
		hasUnavailableProducts:false,
		isDefault:false,
		productCount: 0
	},
	notification:{
		init: false,
		count:0,
		wsConnected: false,
		wsReconnecting: false,
		latestNotification: {},
		latestNotificationShow: false,
		settings: []
	},
	checkoutdata:{
		items:[],
		payerAddress: {}
	}
}





